import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';
import { deliverableRepository } from '../repositories/deliverable.repository';
import { deliverableKeys } from '../services/deliverable.keys';
import type { DeliverableAggregate } from '../types/deliverable.types';

export type { DeliverableAggregate };

export const useDeliverableAggregates = (campaignId: string) => {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id || '';

  return useQuery({
    queryKey: deliverableKeys.campaignAggregates(orgId, campaignId),
    queryFn: async (): Promise<DeliverableAggregate[]> => {
      if (!campaignId || !orgId) return [];
      return deliverableRepository.getCampaignDeliverables(orgId, campaignId);
    },
    enabled: !!campaignId && !!orgId,
    staleTime: 3 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
